import { ModalFooter, ModalFooterButton } from '@/components/Modal'

import { useTexts } from '../hooks/useTexts'
import { useControllerActions } from '../hooks/useControllerActions'
import { useController } from '../hooks/useController'

export function Footer() {
  const texts = useTexts()
  const {
    close,
    data: { bodyPlainText },
  } = useController()
  const actions = useControllerActions(bodyPlainText)

  const [copyText, onCopyText] = actions.copyText

  return (
    <ModalFooter
      primaryAction={
        <ModalFooterButton
          className="pendo-orderform_order-notification-tab-view-settings-copy-text"
          testid="modal-primary-button"
          onClick={onCopyText}
          variant="contained"
        >
          {copyText}
        </ModalFooterButton>
      }
      secondaryAction={
        <ModalFooterButton
          onClick={close}
          className="pendo-orderform_order-notification-tab-view-settings-close-modal"
          testid="modal-secondary-button"
        >
          {texts.close}
        </ModalFooterButton>
      }
    />
  )
}
